import React, { useState } from "react";
import { ScrollView } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import VerificationScreen from "./VerificationScreen";
import Spinner from "../common/Spinner";

const VerificationModal = ({
  visible,
  toggle,
  reports,
  isSaving,
  createTransfers,
  reportType,
}) => {
  const [open, setOpen] = useState(-1);

  const toggleLocation = (id) => {
    if (id === open) {
      setOpen(-1);
    } else {
      setOpen(id);
    }
  };

  const bottonOptions = {
    text: "Continue",
    onClick: createTransfers,
    stylingMode: "contained",
    type: "default",
    disabled: isSaving || (reports && !reports.requestData.length),
  };

  return (
    <Popup
      visible={visible}
      onHiding={toggle}
      closeOnOutsideClick={false}
      title={`The following ${
        reportType === "transferOrder"
          ? "transfer orders"
          : "inventory transfers"
      } will be created:`}
      animation={null}
      //   fullScreen={true}
      dragEnabled={false}
    >
      <ScrollView width="100%" height="100%">
        <div>{isSaving ? <Spinner /> : <div></div>}</div>
        {reports && reports.verifyData.length ? (
          <div className="m-2">
            {reports.verifyData.map((data, i) => (
              <VerificationScreen
                verifyData={data}
                key={i}
                index={i}
                toggle={toggleLocation}
                open={open}
              />
            ))}
          </div>
        ) : (
          <div>
            <h3>No record(s) to transfer</h3>
          </div>
        )}
      </ScrollView>
      <ToolbarItem
        widget="dxButton"
        location="after"
        options={bottonOptions}
      ></ToolbarItem>
    </Popup>
  );
};

export default VerificationModal;
